import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/t_title.png'
import _imports_1 from '../../assets/img/t_city.png'
import _imports_2 from '../../assets/img/t_zz.png'
import _imports_3 from '../../assets/img/t_zt.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-97f5bac8")

_pushScopeId("data-v-97f5bac8")
const _hoisted_1 = { class: "travel" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "travel-title" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    style: {"animation":"slideInDown 1.2s 0s ease forwards"},
    alt: "旅游"
  }),
  /*#__PURE__*/_createVNode("div", {
    class: "app-particles-canvas",
    id: "travel-bg",
    style: {"margin-top":"30vw"}
  })
], -1)
const _hoisted_3 = { class: "travel-city" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", {
  class: "app-particles-canvas",
  id: "bbx"
}, null, -1)
const _hoisted_5 = { class: "travel-city-content" }
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  style: {"width":"90.55vw","margin":"0vw auto 4vw auto","display":"table"},
  alt: ""
}, null, -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<p class=\"active\" style=\"animation-duration:1.5s;animation-delay:0s;\" data-v-97f5bac8>来<span style=\"font-family:&#39;almmdfdk&#39;;color:#ca3935;\" data-v-97f5bac8>中国旅游</span>，City不City啊？</p><p style=\"animation-duration:1.5s;animation-delay:0.3s;\" data-v-97f5bac8>上海City不City啊？</p><p style=\"animation-duration:1.5s;animation-delay:0.6s;\" data-v-97f5bac8>长城City不City啊？</p><p style=\"animation-duration:1.5s;animation-delay:0.9s;\" data-v-97f5bac8>四川火锅City不City啊？</p>", 4)
const _hoisted_12 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<p style=\"animation-duration:1.5s;animation-delay:0.3s;\" data-v-97f5bac8>City不City</p><p style=\"animation-duration:1.5s;animation-delay:0.6s;\" data-v-97f5bac8>是外国博主</p><p class=\"active\" style=\"font-weight:bold;animation-duration:1.5s;animation-delay:0.9s;\" data-v-97f5bac8>保保熊</p><p style=\"animation-duration:1.5s;animation-delay:1.2s;\" data-v-97f5bac8>在中国旅游时</p><p style=\"animation-duration:1.5s;animation-delay:1.5s;\" data-v-97f5bac8>创造的</p><p class=\"active\" style=\"font-size:7.2vw;font-weight:bold;animation-duration:1.5s;animation-delay:1.8s;\" data-v-97f5bac8>网络热梗</p>", 6)
const _hoisted_21 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_23 = { key: 2 }
const _hoisted_24 = /*#__PURE__*/_createStaticVNode("<p style=\"animation-duration:1.5s;animation-delay:0s;\" data-v-97f5bac8>可理解为</p><p style=\"font-size:10vw;font-weight:bolder;color:#231815;line-height:1.2em;animation-duration:1.5s;animation-delay:0.3s;\" data-v-97f5bac8>时髦不时髦</p><p style=\"font-size:10vw;font-weight:bolder;color:#231815;line-height:1.2em;animation-duration:1.5s;animation-delay:0.6s;\" data-v-97f5bac8>洋气不洋气</p><p style=\"animation-duration:1.5s;animation-delay:0.9s;\" data-v-97f5bac8>热梗背后是更热的</p><p style=\"font-family:&#39;almmdfdk&#39;;font-size:10vw;color:#c95245;animation-duration:1.5s;animation-delay:1.2s;\" data-v-97f5bac8>中国旅游</p>", 5)
const _hoisted_29 = { class: "travel-mq" }
const _hoisted_30 = /*#__PURE__*/_createVNode("div", { class: "three-head" }, [
  /*#__PURE__*/_createVNode("div", { class: "three-top" }, "截至2024年8月"),
  /*#__PURE__*/_createVNode("p", null, "我国144小时过境免签政策"),
  /*#__PURE__*/_createVNode("p", null, "适用范围已增至")
], -1)
const _hoisted_31 = {
  key: 0,
  class: "three-bottom"
}
const _hoisted_32 = { class: "three-count" }
const _hoisted_33 = { style: {"display":"flex","align-items":"flex-end"} }
const _hoisted_34 = /*#__PURE__*/_createTextVNode("个")
const _hoisted_35 = { class: "travel-play" }
const _hoisted_36 = {
  key: 0,
  class: "travel-tag"
}
const _hoisted_37 = {
  key: 1,
  class: "travel-play-content",
  style: {"opacity":"0","animation":"fadeInUp 1.2s 0s ease forwards"}
}
const _hoisted_38 = /*#__PURE__*/_createVNode("p", null, "标签火爆全球", -1)
const _hoisted_39 = /*#__PURE__*/_createVNode("p", null, "社交媒体相关视频播放量", -1)
const _hoisted_40 = { class: "four-count" }
const _hoisted_41 = /*#__PURE__*/_createVNode("span", { id: "travel-play-count" }, null, -1)
const _hoisted_42 = { class: "travel-rujing-content" }
const _hoisted_43 = {
  key: 0,
  class: "travel-rujing"
}
const _hoisted_44 = /*#__PURE__*/_createStaticVNode("<p style=\"opacity:0;animation:fadeInUp 1.2s 0s ease forwards;\" data-v-97f5bac8>2024年上半年</p><p style=\"opacity:0;animation:fadeInUp 1.2s 0.2s ease forwards;\" data-v-97f5bac8>全国各口岸入境外国人</p><p style=\"opacity:0;animation:fadeInUp 1.2s 0.2s ease forwards;margin-top:2vw;\" data-v-97f5bac8><span id=\"rj-count\" data-v-97f5bac8></span>万人次</p><p style=\"opacity:0;animation:fadeInUp 1.2s 0.4s ease forwards;\" data-v-97f5bac8>同比增长</p><div class=\"five-bfb\" style=\"opacity:0;animation:fadeInUp 1.2s 0.4s ease forwards;\" data-v-97f5bac8><div data-v-97f5bac8><span id=\"rj-count-bfb\" data-v-97f5bac8></span></div></div>", 5)
const _hoisted_49 = {
  key: 0,
  class: "five-p"
}
const _hoisted_50 = /*#__PURE__*/_createVNode("path", {
  d: "M640.512 258.048H402.432c-26.112 0-47.104 22.016-47.104 48.64l17.408 202.752 0.512 6.144c2.56 14.848 14.848 25.6 30.208 25.6h12.288c9.728 0.512 17.408 8.192 18.944 17.92v2.56l16.384 212.48 0.512 4.608c2.048 15.36 14.848 26.624 30.208 26.624h80.384c14.848 0 27.648-11.264 30.208-26.112l0.512-6.144 16.384-212.48v-2.048c1.024-10.24 9.216-17.92 18.944-18.432h12.288c15.36 0 28.16-11.776 30.208-26.624v-0.512l0.512-3.072 17.92-204.288c-1.536-26.112-22.528-47.616-48.64-47.616z m-118.784-41.472c57.344 0 104.448-48.64 104.448-108.032 0-59.904-46.592-108.032-104.448-108.032-57.856-0.512-104.448 48.128-104.448 107.52 0 59.904 46.592 108.544 104.448 108.544z",
  "p-id": "45084"
}, null, -1)
const _hoisted_51 = { class: "travel-youke" }
const _hoisted_52 = {
  key: 0,
  class: "eight-body"
}
const _hoisted_53 = { class: "eight-item" }
const _hoisted_54 = /*#__PURE__*/_createVNode("span", {
  class: "eight-count",
  style: {"color":"#609e71"},
  id: "t-yk"
}, null, -1)
const _hoisted_55 = /*#__PURE__*/_createVNode("div", { class: "eight-intro" }, [
  /*#__PURE__*/_createTextVNode(" 国内游客 "),
  /*#__PURE__*/_createVNode("span", null, "单位：百万次")
], -1)
const _hoisted_56 = { class: "eight-item" }
const _hoisted_57 = /*#__PURE__*/_createVNode("span", {
  class: "eight-count",
  style: {"color":"#6ccece"},
  id: "t-hf"
}, null, -1)
const _hoisted_58 = /*#__PURE__*/_createVNode("div", { class: "eight-intro" }, [
  /*#__PURE__*/_createTextVNode(" 国内旅游总花费 "),
  /*#__PURE__*/_createVNode("span", null, "单位：百万次")
], -1)
const _hoisted_59 = {
  key: 1,
  id: "travel-year"
}
const _hoisted_60 = { class: "travel-gaige" }
const _hoisted_61 = { key: 0 }
const _hoisted_62 = /*#__PURE__*/_createStaticVNode("<p style=\"animation-duration:1.5s;animation-delay:0s;\" data-v-97f5bac8>改革开放以来</p><p style=\"animation-duration:1.5s;animation-delay:0.3s;\" data-v-97f5bac8>我国的旅游业从小到大、由弱渐强</p><p style=\"animation-duration:1.5s;animation-delay:0.6s;\" data-v-97f5bac8>日益成为新兴的战略性支柱产业和</p><p style=\"animation-duration:1.5s;animation-delay:0.9s;\" data-v-97f5bac8>具有显著时代特征的民生产业、幸福产业</p><p style=\"font-size:6vw;color:#c95245;font-weight:bold;line-height:1.4em;animation-duration:1.5s;animation-delay:1.2s;\" data-v-97f5bac8>成功走出了</p><p style=\"font-size:6vw;color:#c95245;font-weight:bold;line-height:1.4em;animation-duration:1.5s;animation-delay:1.5s;\" data-v-97f5bac8>一条独具特色的</p><p style=\"font-size:6vw;color:#c95245;font-weight:bold;line-height:1.4em;animation-duration:1.5s;animation-delay:1.8s;\" data-v-97f5bac8>中国旅游发展之路</p>", 7)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TravelCountry = _resolveComponent("TravelCountry")
  const _component_TextParticle = _resolveComponent("TextParticle")

  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode("div", _hoisted_5, [
        _hoisted_6,
        (_ctx.isShowCityStep >= 1)
          ? (_openBlock(), _createBlock("div", _hoisted_7, [
              _hoisted_8
            ]))
          : _createCommentVNode("", true),
        _hoisted_12,
        _hoisted_13,
        (_ctx.isShowCityStep >= 2)
          ? (_openBlock(), _createBlock("div", _hoisted_14, [
              _hoisted_15
            ]))
          : _createCommentVNode("", true),
        _hoisted_21,
        _hoisted_22,
        (_ctx.isShowCityStep >= 3)
          ? (_openBlock(), _createBlock("div", _hoisted_23, [
              _hoisted_24
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode("div", _hoisted_29, [
      _hoisted_30,
      (_ctx.isShowMqCountry)
        ? (_openBlock(), _createBlock("div", _hoisted_31, [
            _createVNode(_component_TravelCountry, { count: _ctx.countryCount }, null, 8, ["count"]),
            _createVNode("div", _hoisted_32, [
              _createVNode("div", _hoisted_33, [
                _createVNode("span", {
                  id: "mqCountry",
                  style: `color: ${ _ctx.countryCount === 37 ? '#68d4b6' : '#19b0e7' }`
                }, "0", 4),
                _hoisted_34
              ]),
              _createVNode("div", null, [
                _createVNode("p", null, _toDisplayString(_ctx.countryCount === 37 ? '口岸' : '国家'), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_35, [
      (_ctx.isShowTag)
        ? (_openBlock(), _createBlock("div", _hoisted_36, [
            _createVNode(_component_TextParticle)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isShowTag)
        ? (_openBlock(), _createBlock("div", _hoisted_37, [
            _hoisted_38,
            _hoisted_39,
            _createVNode("div", _hoisted_40, [
              _hoisted_41,
              _createTextVNode(_toDisplayString(_ctx.isEndTravelPlay ? '+' : ''), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_42, [
      (_ctx.isShowMqrj === 1)
        ? (_openBlock(), _createBlock("div", _hoisted_43, [
            _hoisted_44,
            (_ctx.isShowMqPeopleList)
              ? (_openBlock(), _createBlock("div", _hoisted_49, [
                  (_openBlock(), _createBlock(_Fragment, null, _renderList(375, (item) => {
                    return _createVNode("svg", {
                      class: "icon",
                      style: `animation: ${ _ctx.peopleAnimationsName[item] } ${ _ctx.peopleAnimationsTimes[item] }s ${ _ctx.peopleAnimationsDes[item] }s ease forwards;`,
                      viewBox: "256 -128 512 1024",
                      version: "1.1",
                      xmlns: "http://www.w3.org/2000/svg",
                      key: item,
                      fill: item <= 250 ? '#68d4b6' : '#19b0e7'
                    }, [
                      _hoisted_50
                    ], 12, ["fill"])
                  }), 64))
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_51, [
      (_ctx.isShowYouke)
        ? (_openBlock(), _createBlock("div", _hoisted_52, [
            _createVNode("div", _hoisted_53, [
              _hoisted_54,
              (_openBlock(), _createBlock(_Fragment, null, _renderList(3, (item, index) => {
                return _createVNode("img", {
                  src: _imports_2,
                  key: item,
                  alt: ""
                })
              }), 64)),
              _hoisted_55
            ]),
            _createVNode("div", _hoisted_56, [
              _hoisted_57,
              (_openBlock(), _createBlock(_Fragment, null, _renderList(4, (item, index) => {
                return _createVNode("img", {
                  src: _imports_3,
                  key: item,
                  alt: ""
                })
              }), 64)),
              _hoisted_58
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isShowYouke)
        ? (_openBlock(), _createBlock("div", _hoisted_59))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_60, [
      (_ctx.isShowMqGaige)
        ? (_openBlock(), _createBlock("div", _hoisted_61, [
            _hoisted_62
          ]))
        : _createCommentVNode("", true)
    ])
  ], 512)), [
    [_vShow, _ctx.isShow]
  ])
})